export default "__VITE_ASSET__D0YRW5MD__"